import { render, staticRenderFns } from "./create-prize.vue?vue&type=template&id=c0eb6022&scoped=true&"
import script from "./create-prize.vue?vue&type=script&lang=js&"
export * from "./create-prize.vue?vue&type=script&lang=js&"
import style0 from "./create-prize.vue?vue&type=style&index=0&id=c0eb6022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0eb6022",
  null
  
)

export default component.exports